/**
 * FieldError — muestra un mensaje de error inline bajo un campo.
 */
export function FieldError({ msg }) {
  if (!msg) return null;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 5,
        marginTop: 4,
        color: "#f87171",
        fontSize: "0.78rem",
      }}
    >
      <i
        className="fa-solid fa-circle-exclamation"
        style={{ fontSize: "0.72rem" }}
      />
      {msg}
    </div>
  );
}

/**
 * CedulaStatus — muestra el resultado de la búsqueda de cédula.
 */
export function CedulaStatus({ estado }) {
  if (estado === "idle") return null;

  const cfg = {
    buscando: {
      color: "#60a5fa",
      icon: "fa-circle-notch fa-spin",
      text: "Buscando…",
    },
    local: {
      color: "#4ade80",
      icon: "fa-circle-check",
      text: "Datos cargados desde el registro local",
    },
    tse: {
      color: "#4ade80",
      icon: "fa-circle-check",
      text: "Datos cargados desde el TSE (Registro Nacional CR)",
    },
    no_encontrado: {
      color: "#fbbf24",
      icon: "fa-triangle-exclamation",
      text: "Cédula no encontrada. Ingresá el nombre manualmente.",
    },
    error: {
      color: "#f87171",
      icon: "fa-circle-exclamation",
      text: "No se pudo consultar el registro. Ingresá el nombre manualmente.",
    },
  }[estado];

  if (!cfg) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        marginTop: 5,
        color: cfg.color,
        fontSize: "0.78rem",
      }}
    >
      <i className={`fa-solid ${cfg.icon}`} />
      {cfg.text}
    </div>
  );
}

/**
 * ForeignToggle — chip seleccionable "Es número extranjero" para teléfono/placa.
 * Se ve como una etiqueta tipo píldora: gris cuando está apagada, naranja al activarla.
 */
export function ForeignToggle({ checked, onChange, label }) {
  return (
    <label
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        marginTop: 7,
        padding: "3px 10px",
        borderRadius: 999,
        border: `1px solid ${checked ? "rgba(249,115,22,0.55)" : "var(--border-card, rgba(148,163,184,0.3))"}`,
        background: checked ? "rgba(249,115,22,0.12)" : "transparent",
        fontSize: "0.74rem",
        fontWeight: 600,
        color: checked ? "#fb923c" : "var(--text-muted)",
        userSelect: "none",
        cursor: "pointer",
        transition: "all 0.15s",
        width: "fit-content",
      }}
    >
      <input
        type="checkbox"
        checked={!!checked}
        onChange={onChange}
        style={{ display: "none" }}
      />
      <i
        className={`fa-solid ${checked ? "fa-circle-check" : "fa-globe"}`}
        style={{ fontSize: "0.7rem" }}
      />
      {label}
    </label>
  );
}

/**
 * SectionLabel — separador de sección dentro de un step del wizard.
 * Texto pequeño en mayúsculas con línea divisoria a la derecha.
 */
export function SectionLabel({ icon, children }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        marginTop: 6,
      }}
    >
      <span
        style={{
          display: "flex",
          alignItems: "center",
          gap: 7,
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.8px",
          textTransform: "uppercase",
          color: "#f97316",
          whiteSpace: "nowrap",
        }}
      >
        {icon && <i className={`fa-solid ${icon}`} style={{ fontSize: "0.72rem" }} />}
        {children}
      </span>
      <span style={{ flex: 1, height: 1, background: "var(--border-card, rgba(148,163,184,0.18))" }} />
    </div>
  );
}
